import { useState, useLayoutEffect, useEffect, useMemo, useCallback } from 'react'
import { Box } from '@mui/material'
import Header from './header'
import Aside from './aside'
import { useStyles } from './styles'
import { useContextState } from '../../hooks/theme'
import { useListItem } from './aside/items'
import { Props } from './types'
import { useLocation, useNavigate } from 'react-router-dom'
import { httpFetch, } from '../../utils/crud'
import Loader from '../loader'
import { Auth } from '../../service'
import { Items } from './aside/types'
import { getUserRole } from '../../service/auth'
import { Roles, Types } from '../../utils/enums'
import { QuestionnaireLocale } from '../../pages/questionnaire/pages/main/typing/enums'
import { userServiceFetch } from '../../utils/constants/callService'
import { TypeGlobalEnum } from '../../utils/enums/globalContextEnum'
import { getLocalStorage, LocaleNameType, setLocalStorage } from '../../utils/crud/crypt'
import { ItemNotifyProps } from './header/components/itemNotificationBell/types'
import { format } from 'date-fns'
import { Constants } from '../../utils/constants'

const Layout = ({ children }: Props) => {
  const { dispatch, state: stateContext, colors, handleTheme } = useContextState()
  const state = getLocalStorage(LocaleNameType.QUESTIONNAIRE)
  const role = getUserRole()
  const location = useLocation()
  const [open, setOpen] = useState(true)
  const [show, setShow] = useState<any>()
  const [listLoadingNotifications, setListLoadingNotifications] = useState<
    Record<string, boolean>
  >({})
  const [snackbar, setSnackbar] = useState({
    open: false,
    type: Types.SUCCESS,
    message: '',
  })
  const [isLoading, setIsLoading] = useState(true)
  const listItems = useListItem()
  const [notifications, setNotifications] = useState<ItemNotifyProps[]>([])
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [totalItems, setTotalItems] = useState(0)
  const [loading, setLoading] = useState<Record<string, boolean>>({
    notification: true,
    initial: true,
    secondPages: false
  })
  const navigate = useNavigate()
  // const isSupervisor = canAccess([Roles.SUPERVISOR])
  const path = useMemo(() => location.pathname.replace('/', ''), [location.pathname])
  /* const getPath = useMemo(() => {
    return listItems.findIndex((item) => {
      if (item.children) {
        return item.children.findIndex((child) => path.includes(child.path)) >= 0
      } else {
        if (path === item.path) {
          return path === item.path
        } else {
          return item.extraPaths?.some((item) => path.includes(item))
        }
      }
    })
  }, [path, listItems]) */

  const getPathIndex = (path: string, items: Items[]): number => {
    return items.findIndex((item) => {
      if (item.children) {
        return item.children.findIndex((child) => path.includes(child.path)) >= 0;
      } else if (path === item.path) {
        return true;
      } else {
        return item.extraPaths?.some((extraPath) => path.includes(extraPath));
      }
    });
  };

  const allowedRoute = () => {
    // let finded = false
    const pathLenght = path?.split('/')
    const splitPath = path?.split('/').slice(1)
    if (!splitPath?.length && !pathLenght?.[0]) { return false }
    const permissionList = listItems?.find(item => item.base == splitPath[0])
    if (!!role && permissionList?.access?.includes(role)) {
      if (!permissionList.children?.length) {
        return true
      }

      const blockList = permissionList?.children?.find(item => item.base == splitPath[1])
      if (!!blockList && !blockList?.notAllowedRoles?.includes(role)) { return true }

      return false
    }
    return true
  }

  const [position, setPosition] = useState(/* getPath >= 0 ? getPath : */ 0)

  useEffect(() => {
    const index = getPathIndex(path, listItems);
    setPosition(index >= 0 ? index : 0);
  }, [path, listItems]);

  const verifyToken = (pathName: string, index: number) => {
    if (pathName) {
      if (path !== pathName) {
        setIsLoading(true)
        Auth(httpFetch)
          .decodeJWT({ token: getLocalStorage()?.token ?? '' })
          .then(() => { setIsLoading(false) })
          .catch(() => { })
      }
      setPosition(index)
      navigate(pathName)
    } else {
      setOpen(true)
    }
  }

  const filterSubMenu = (menu: Items[]) => {
    let newMenu = [...menu]
    newMenu.forEach((e) => {
      const { children } = e
      let newChildren: Items[] = []
      if (children) {
        children.forEach((child) => {
          const { notAllowedRoles } = child
          if (!(notAllowedRoles && notAllowedRoles.includes(role as Roles))) { newChildren.push(child) }
        })
        e.children = newChildren
      }
    })

    return newMenu
  }

  const styles = useStyles(colors, open)

  const getNotifications = async (unique?: boolean) => {
    try {
      setLoading((prev) => ({
        ...prev,
        notification: page==1 ? !unique : false,
        secondPages: page!==1
      }))
      const response = await userServiceFetch.notifications(`page=${page}&size=${50}`)

      const notifyConrted: ItemNotifyProps[] = response.items
        .sort((a, b) => {
          if (
            new Date(a.createTime).getTime() >
            new Date(b.createTime).getTime()
          )
            return -1
          return 1
        })
        .map((item) => ({
          id: item.id.toString() ?? '',
          date: format(
            new Date(item.createTime),
            Constants.dateFormatGeneral
          ),
          title: item.title,
          description: item.description,
          type: item.notificationTypeId,
          reportUrl: item.reportUrl
        }))

      setNotifications((prev) =>
        page === 1 ? notifyConrted : [...prev, ...notifyConrted]
      )
      setTotalPages(response.totalPages)
      setTotalItems(response.totalItems)
    } catch (e) {
      if (page === 1) setNotifications([])
    } finally {
      setLoading((prev) => ({
        ...prev,
        notification: false,
        secondPages: false
      }))
    }
  }


  const removeNotifications = async ({
    id,
    all,
  }: {
    id?: string[]
    all?: boolean
  }) => {
    let data: string[] = []

    if (id) {
      data = id
      setListLoadingNotifications(prev => ({
        ...prev,
        [id.toString()]: true
      }))
    } else if (all) {
      setLoading((prev) => ({ ...prev, notification: true }))
    }

    if (id || all) {

      let response;

      if (id) {
        response = await userServiceFetch.deleteNotifications({ body: { id: data } })
      } else {
        response = await userServiceFetch.deleteAllNotifications()
      }

      if (!response?.errors) {
        if (id) {
          // filtrar localmente
          setNotifications(prev => prev.filter(n => !data.includes(String(n.id))))
          setListLoadingNotifications(prev => {
            const newState = { ...prev }
            delete newState[id.toString()]
            return newState
          })
          setTotalItems(totalItems-1)
        } else {
          // recargar todo si eliminaste todas
          setPage(1)
          getNotifications()
        }
        setSnackbar((prev) => ({
          ...prev,
          open: true,
          type: Types.SUCCESS,
          message: id
            ? 'La notificación se descartó exitosamente'
            : 'Todas las notificaciones se descartaron exitosamente',
        }))
      } else {
        setSnackbar((prev) => ({
          ...prev,
          open: true,
          type: Types.ERROR,
          message: id
            ? 'Ocurrió un error al descartar la notificacion'
            : 'Ocurrió un error al descartar las notificaciones',
        }))
      }
    }
  }


  const closeSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }))
  }
  const initialData = useCallback(async () => {
    const setting = getLocalStorage(LocaleNameType.SETTING)
    if (setting.color) {
      handleTheme({ color: setting.color })
    }
    const state = getLocalStorage(LocaleNameType.STATE)
    const token = state?.token ?? ''

    const user = await Auth(httpFetch).decodeJWT({ token })
    const userId = user?.data?.data?.userId
    if (userId) {
      const response = await userServiceFetch.userById(userId)
      const company = response?.userCompanyUserType?.[0]?.company
      setIsLoading(false)

      const body = {
        curp: response.curp,
        role: response.roleId,
        roleName: response?.role?.description,
        picture: response.picture,
        userType: response.userType,
        phone: response.phone,
        fullName: `${response.firstName ?? ''} ${response.lastName ?? ''}`,
        company: company,
        isManagerOfDeparment: state.isManagerOfDeparment
      }

      setLocalStorage({ name: LocaleNameType.STATE, body: { ...state ?? {}, ...body } })
      dispatch({ type: TypeGlobalEnum.SAVE_STATE, payload: { ...stateContext, ...body } })
      //getNotifications()
      setLoading(prev => ({ ...prev, initial: false }))
    }
  }, [])

  useLayoutEffect(() => {
    setIsLoading(true)
    setLoading(prev => ({ ...prev, initial: true }))
    initialData()
  }, [initialData])

  useEffect(() => {
    if (!allowedRoute()) {
      if (!!listItems?.[0]?.path) {
        navigate(listItems[0].path)
      }
    }
  }, [listItems])

  useEffect(() => {
    //setPosition(getPath >= 0 ? getPath : 0)
    if (!location.pathname.includes('questionnarie') && !!state) {
      localStorage.removeItem(QuestionnaireLocale.QUESTIONNAIRE)
      // window.history.replaceState({}, '')
      // navigate(location.pathname, { replace: true });
    }
    // eslint-disable-next-line
  }, [location.pathname])

  useEffect(() => {
    getNotifications()
  }, [page])
  return (
    <Box sx={styles.container}>

      {/* Header */}

      <Box sx={styles.header}>
        <Header
          closeSnackbar={closeSnackbar}
          removeNotifications={removeNotifications}
          listLoadingNotifications={listLoadingNotifications}
          snackbar={snackbar}
          getNotifications={getNotifications}
          loading={loading}
          notifications={notifications}
          openMenu={() => {
            setOpen(!open)
          }}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          totalItems={totalItems}
        />
      </Box>
      {/* Body */}
      <Box sx={styles.body} >
        <Box id="body-custom" sx={styles.content}>{isLoading ? <Loader /> : children}</Box>
      </Box>
      {/* Drawer */}
      <Box sx={styles.menuSmall}>
        <Aside handleChange={verifyToken} open={open} setOpen={setOpen} pathList={filterSubMenu(listItems)} position={position} show={show} setShow={setShow} variant="persistent" />
      </Box>
      <Box sx={styles.menuLg}>
        <Aside handleChange={verifyToken} open={false} setOpen={setOpen} pathList={filterSubMenu(listItems)} position={position} show={show} setShow={setShow} />

        <Box sx={styles.showAside}>
          <Aside handleChange={verifyToken} open={true} setOpen={setOpen} pathList={filterSubMenu(listItems)} position={position} show={show} setShow={setShow} />
        </Box>
      </Box>
    </Box>
  )
}

export default Layout
